module.exports = __webpack_public_path__ + "static/media/dot.07557fbd.svg";